import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ExpressCheckInOutIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ExpressCheckInOutIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M14.4993 7.95426C15.4834 7.95426 16.2841 7.15357 16.2841 6.16939C16.2841 5.18521 15.4834 4.38452 14.4993 4.38452C13.5151 4.38452 12.7144 5.18521 12.7144 6.16939C12.7144 7.15357 13.5151 7.95426 14.4993 7.95426ZM14.4993 5.57443C14.8273 5.57443 15.0942 5.84133 15.0942 6.16939C15.0942 6.49745 14.8273 6.76435 14.4993 6.76435C14.1712 6.76435 13.9043 6.49745 13.9043 6.16939C13.9043 5.84133 14.1712 5.57443 14.4993 5.57443Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M10.9295 18.4255H3.43307V14.1121H9.73961C10.0682 14.1121 10.3346 13.8457 10.3346 13.5171C10.3346 13.1885 10.0682 12.9221 9.73961 12.9221H4.50399V10.4531C4.50399 10.125 4.77089 9.85811 5.09895 9.85811H7.47878C7.80684 9.85811 8.07374 10.125 8.07374 10.4531V11.1373C8.07374 11.4659 8.3401 11.7322 8.6687 11.7322C8.9973 11.7322 9.26366 11.4659 9.26366 11.1373V10.4531C9.26366 9.46889 8.46297 8.6682 7.47879 8.6682H5.09896C4.11478 8.6682 3.31409 9.46889 3.31409 10.4531V12.9221H2.83812C2.50953 12.9221 2.24316 13.1885 2.24316 13.5171V19.6154H10.9295C11.2581 19.6154 11.5245 19.349 11.5245 19.0204C11.5245 18.6918 11.2581 18.4255 10.9295 18.4255Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.4376 7.984C7.42178 7.984 8.22247 7.18331 8.22247 6.19913C8.22247 5.21495 7.42178 4.41426 6.4376 4.41426C5.45342 4.41426 4.65273 5.21495 4.65273 6.19913C4.65273 7.18331 5.45342 7.984 6.4376 7.984ZM6.4376 5.60417C6.76566 5.60417 7.03256 5.87107 7.03256 6.19913C7.03256 6.52719 6.76566 6.79409 6.4376 6.79409C6.10954 6.79409 5.84264 6.52719 5.84264 6.19913C5.84264 5.87107 6.10954 5.60417 6.4376 5.60417Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M15.6892 8.51946H13.3094C12.3252 8.51946 11.5245 9.32015 11.5245 10.3043V13.5468C11.5245 14.3225 12.0218 14.9842 12.7144 15.2298V19.0204C12.7144 19.349 12.9808 19.6154 13.3094 19.6154C13.638 19.6154 13.9043 19.349 13.9043 19.0204V14.7368C13.9043 14.4082 13.638 14.1418 13.3094 14.1418C12.9813 14.1418 12.7144 13.8749 12.7144 13.5468V10.3043C12.7144 9.97626 12.9813 9.70936 13.3094 9.70936H15.6892C16.0172 9.70936 16.2841 9.97626 16.2841 10.3043V13.5468C16.2841 13.8749 16.0172 14.1418 15.6892 14.1418C15.3606 14.1418 15.0942 14.4082 15.0942 14.7368V19.0204C15.0942 19.349 15.3606 19.6154 15.6892 19.6154C16.0178 19.6154 16.2841 19.349 16.2841 19.0204V15.2298C16.9767 14.9842 17.4741 14.3225 17.4741 13.5468V10.3043C17.4741 9.32015 16.6734 8.51946 15.6892 8.51946Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M20.3773 12.7859H17.2079C16.8851 12.7859 16.6234 12.5245 16.6234 12.2014C16.6234 11.8784 16.8851 11.6169 17.2079 11.6169H20.3773C20.7001 11.6169 20.9618 11.8784 20.9618 12.2014C20.9618 12.5245 20.7001 12.7859 20.3773 12.7859Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M19.3667 15.2404H16.2224C15.8997 15.2404 15.6379 14.9789 15.6379 14.6559C15.6379 14.3328 15.8997 14.0714 16.2224 14.0714H19.3667C19.6895 14.0714 19.9512 14.3328 19.9512 14.6559C19.9512 14.9789 19.6895 15.2404 19.3667 15.2404Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5323 17.6948H16.0121C15.6893 17.6948 15.4276 17.4334 15.4276 17.1103C15.4276 16.7872 15.6893 16.5258 16.0121 16.5258H21.5323C21.8551 16.5258 22.1168 16.7872 22.1168 17.1103C22.1168 17.4334 21.8551 17.6948 21.5323 17.6948Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ExpressCheckInOutIcon;
